export default __webpack_public_path__ + "static/media/vf-assigned-to-user.ae56b695.svg";